// extracted by mini-css-extract-plugin
module.exports = {"section":"stats-bloc_section__1-OA7","title":"stats-bloc_title__WA6JX","number":"stats-bloc_number__9YtL7"};